export default function(ngModule) {
    /**
     * @ngdoc service
     * @name eventix.common.models.Collapse
     * @kind class
     * @description
     * A Collapse contains tickets, and can be collapsed in the shops
     */
    ngModule.factory('Collapse', function(BaseClass, $q, $http, sortByPredecessor) {

        /**
         * Constructor function
         *
         * @constructor
         * @param {Object} attributes Initial attributes for the model
         */
        function Collapse(attributes) {
            _.assign(this, attributes);
        }
        Collapse.modelName = 'Collapse';

        BaseClass.apply(Collapse);

        Collapse.validates({
            title: {
                required: true
            },
            start_open: {
                format: { boolean: true }
            },
            pre_tickets: {
                format: { boolean: true }
            },
            pre_title: {},
            pre_content: {},
            inner_title: {},
            inner_content: {},
            post_content: {}
        });

        Collapse.configureApi('/collapse/:guid', { queryAdmin: '/collapse/:status/:company', reinstate: '/collapse/:guid/reinstate' });
        Collapse.prototype.toString = function() { return this.name; };
        Collapse.prototype.$reinstate = () => $http.post(`/collapse/${this.guid}/reinstate`);
        Collapse.queryDeleted = function() {
            return $http.get('/collapse/trashed').then( result => {
                var models = _.map(result.body, Collapse.new);
                return $q.resolve(models);
            });
        };

        Collapse.belongsToMany('Ticket', 'tickets', '/collapse/:guid/tickets/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            { type: 'query' }
        ]);

        Collapse.prototype.hasAvailableTicketsFromSet = function(tickets) {
            return _.some(tickets, ticket => _.includes(this.ticket_guids, ticket.guid) && ticket.available);
        };

        Collapse.prototype.hasTicket = function(ticket) {
            return _.includes(this.ticket_guids, ticket.guid);
        };

        return Collapse;
    });
}
